import MAP from './map';

export default MAP;
